import Request from './request'

const Task = {
  getTasks (params, callback) {
    Request.get('device-task', params).then(callback).catch(this.bad_answer)
  },
  getTaskStatuses (callback) {
    Request.get('device-task/statuses').then(callback).catch(this.bad_answer)
  },
  getDeviceTask (id, callback) {
    Request.get('device-task/device/' + id).then(callback).catch(this.bad_answer)
  },
  getDeviceTaskInfo (id, callback) {
    Request.get('device-task/view/' + id).then(callback).catch(this.bad_answer)
  },
  updateStatusTask(id, params, callback) {
    Request.post('device-task/update-status/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}
export default Task
